import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { MobileNav } from "./header/MobileNav";
import { DesktopNav } from "./header/DesktopNav";

export const LandingHeader = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGetStarted = () => {
    navigate('/auth?signup=true');
  };

  const handleLogin = () => {
    navigate('/auth');
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 z-50 border-b transition-all duration-200 ${
        isScrolled ? 'shadow-sm' : ''
      }`}
    >
      <div className="container mx-auto px-4 py-2.5 h-16 flex items-center justify-between">
        <img 
          src="/lovable-uploads/d8edf8a7-daeb-4805-8270-304464f41613.png" 
          alt="MindTube" 
          className="h-8 transition-transform duration-200 hover:scale-105 cursor-pointer"
          onClick={() => navigate('/landing')}
        />

        <DesktopNav onLogin={handleLogin} onGetStarted={handleGetStarted} />

        {/* Mobile Navigation */}
        <div className="flex items-center gap-3 md:hidden">
          <Button 
            onClick={handleGetStarted} 
            size="sm"
            className="min-h-[44px]"
          >
            Get Started <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <MobileNav onLogin={handleLogin} />
        </div>
      </div>
    </header>
  );
};